export const ATTESTATIONS = ['eligible', 'advantages', 'quote', 'appointment'] as const

export type Attestation = (typeof ATTESTATIONS)[number]

export interface VoltalisSlot {
  startDate: string
  endDate: string
  slotId?: string | number
  serviceProviderId?: string | number
  state?: string
}

export interface VoltalisAvailabilities {
  validated?: unknown
  error?: unknown
  dates?: Array<{ date: string; slots?: VoltalisSlot[] }>
}

export interface VoltalisStatusData {
  statusCode?: string | null
  statusDescription?: string | null
  scriptSteps?: Record<string, string> | null
  availabilities?: VoltalisAvailabilities | null
  infoAttributes?: { availabilities?: VoltalisAvailabilities | null; signatureLink?: string | null } | null
}

export const availabilitiesOf = (data: VoltalisStatusData = {}) =>
  data.infoAttributes?.availabilities ?? data.availabilities ?? null

export const areAttestationsDone = (data: VoltalisStatusData = {}) =>
  ATTESTATIONS.every(key => !!data.scriptSteps?.[key])

export const isAppointmentSent = (data: VoltalisStatusData = {}) =>
  data.statusCode === 'customer_call' || !!availabilitiesOf(data)?.validated

export const isQuoteSigned = (data: VoltalisStatusData = {}) => data.statusCode === 'signed' || isAppointmentSent(data)
